<template>
  <aside
    class="side-bar"
    :class="{wide: isWide}"
  >
    <div class="logo">
      <LogoWithTitle v-if="isWide" />
      <Logo v-else />
    </div>
    <ul class="menu-list">
      <template v-for="(menu, index) in menus">
        <li
          v-if="canIAccessToThisPage(menu)"
          :key="index"
          class="nav-link"
        >
          <nav-menu
            :menuName="menu.title"
            :isWide="isWide"
          />
        </li>
      </template>
    </ul>
  </aside>
</template>

<script>
import MAIN_FEATURES from '@/misc/mainFeatures'
import { mapGetters } from 'vuex'
import NavMenu from './NavMenu'
import Logo from '@/assets/logos/logo.svg'
import LogoWithTitle from '@/assets/logos/logo-with-title.svg'

const NEW_BALANCE_STORE_ID = 423

export default {
  components: {
    Logo,
    LogoWithTitle,
    NavMenu
  },
  props: {
    isWide: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      menus: MAIN_FEATURES
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/getUserInfo',
      currentStore: 'user/getCurrentStore'
    })
  },
  methods: {
    // todo: temporary function
    canIAccessToThisPage (menuItem) {
      if (menuItem.admin) {
        if (menuItem.name === 'datalink' && this.currentStore.store_id === NEW_BALANCE_STORE_ID) {
          return true
        }
        if (!this.userInfo.is_admin) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.side-bar {
  width: 80px;
  min-height: 100%;
  background-color: #1a1a1a;

  .logo {
    height: 80px;
    padding: 25px 0;
    text-align: center;
  }
}

.wide {
  width: 180px;
}
</style>
